import * as React from 'react'
import { Route, BrowserRouter } from 'react-router-dom'
import Home from '@component/Home';
import Detail from '@component/Detail';
import MobileHome from '@component/Mobile/Home';
import GameDetailHome from '@component/Mobile/GameDetail';
import GameDetail from '@component/GameDetail';
import NewsDetailHome from '@component/Mobile/NewsDetail';
import MobileNews from '@component/Mobile/News';
import News from '@component/News';
import MobileAboutUs from '@component/Mobile/AboutUs';
import MobileJoinUs from '@component/Mobile/JoinUs';
import AboutUs from '@component/AboutUs';
import JoinUs from '@component/JoinUs';

export default class Routes extends React.Component {
  public render() {
    const currentHome = sessionStorage.getItem('mobile') === 'true' ? MobileHome : Home
    return (
      <BrowserRouter>
        <Route exact={true} path='/' component={ currentHome } />
        <Route path='/mobileHome' component={ MobileHome } />
        <Route path='/detail/:id' component={ Detail } />
        <Route path='/gemeDetailHome/:id' component={ GameDetailHome } />
        <Route path='/gameDetail/:id' component={ GameDetail } />
        <Route path='/newsDetailHome/:id' component={ NewsDetailHome } />
        <Route path='/mobileNews' component={ MobileNews } />
        <Route path='/news' component={ News } />
        <Route path='/mobileAboutUs' component={ MobileAboutUs } />
        <Route path='/mobileJoinUs' component={ MobileJoinUs } />
        <Route path='/aboutUs' component={ AboutUs } />
        <Route path='/joinUs' component={ JoinUs } />
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/router/Routes.tsx